export class CreatePaymentMethodResponseDTO{
    url!: string;
    sessionId!: string;

    constructor(data: CreatePaymentMethodResponseDTO){
        Object.assign(this, data);
    }
}